import { event_service } from '../constants/Event.constants';

const initialState = {
    eventLoading: false,
    eventList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case event_service.FETCH_EVENT_SERVICES_SUCCESS:
      return {
        ...state,
        eventList: action.payload,
      };
    case event_service.FETCH_EVENT_SERVICES_LOADING:
      return { ...state, eventLoading: action.payload };

    default:
      return state;
  }
};

export default reducer;
